"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCallToActionRequestToJSON = exports.AdCallToActionRequestFromJSONTyped = exports.AdCallToActionRequestFromJSON = exports.instanceOfAdCallToActionRequest = void 0;
var runtime_1 = require("../runtime");
var AdCallToActionType_1 = require("./AdCallToActionType");
var AdLanguage_1 = require("./AdLanguage");
var ClickthroughApplicationLink_1 = require("./ClickthroughApplicationLink");
/**
 * Check if a given object implements the AdCallToActionRequest interface.
 */
function instanceOfAdCallToActionRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCallToActionRequest = instanceOfAdCallToActionRequest;
function AdCallToActionRequestFromJSON(json) {
    return AdCallToActionRequestFromJSONTyped(json, false);
}
exports.AdCallToActionRequestFromJSON = AdCallToActionRequestFromJSON;
function AdCallToActionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': !(0, runtime_1.exists)(json, 'key') ? undefined : (0, AdCallToActionType_1.AdCallToActionTypeFromJSON)(json['key']),
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : (0, AdLanguage_1.AdLanguageFromJSON)(json['language']),
        'locale': !(0, runtime_1.exists)(json, 'locale') ? undefined : json['locale'],
        'clickthroughUrl': !(0, runtime_1.exists)(json, 'clickthrough_url') ? undefined : json['clickthrough_url'],
        'clickthroughUri': !(0, runtime_1.exists)(json, 'clickthrough_uri') ? undefined : json['clickthrough_uri'],
        'clickthroughApplicationLink': !(0, runtime_1.exists)(json, 'clickthrough_application_link') ? undefined : (0, ClickthroughApplicationLink_1.ClickthroughApplicationLinkFromJSON)(json['clickthrough_application_link']),
    };
}
exports.AdCallToActionRequestFromJSONTyped = AdCallToActionRequestFromJSONTyped;
function AdCallToActionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': (0, AdCallToActionType_1.AdCallToActionTypeToJSON)(value.key),
        'language': (0, AdLanguage_1.AdLanguageToJSON)(value.language),
        'locale': value.locale,
        'clickthrough_url': value.clickthroughUrl,
        'clickthrough_uri': value.clickthroughUri,
        'clickthrough_application_link': (0, ClickthroughApplicationLink_1.ClickthroughApplicationLinkToJSON)(value.clickthroughApplicationLink),
    };
}
exports.AdCallToActionRequestToJSON = AdCallToActionRequestToJSON;
